import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FaqsItem from 'components/marketingSite/shared/FaqsItem';
import { ButtonLink } from 'components/shared/ButtonLink';
import { Heading2 } from 'components/shared/Typography';
import { useI18n } from 'hooks/useI18n';
import { useRouter } from 'next/router';
import { APP_URLS, getAppUrl } from 'utils/app-urls';
import { getPublicPath } from 'utils/paths';
import { StyledContainer, StyledNews } from './LaunchNews.styled';

const LaunchNews: React.FC = () => {
  const { t } = useI18n('launch-landing');
  const { locale } = useRouter();

  const news = [
    {
      // getPublicPath('/images/launch/autonomy.gif')
      active: true,
      question: t('news.autonomy.title'),
      answer: t('news.autonomy.desc', {
        img: getPublicPath('/images/launch/autonomy.gif')
      })
    },
    {
      question: t('news.time.title'),
      answer: t('news.time.desc')
    },
    {
      question: t('news.security.title'),
      answer: t('news.security.desc')
    },
    {
      // getPublicPath('/images/launch/roles.gif')
      question: t('news.standard.title'),
      answer: t('news.standard.desc', {
        img: getPublicPath('/images/launch/roles.gif')
      })
    },
    {
      question: t('news.sync.title'),
      answer: t('news.sync.desc')
    },
    {
      // getPublicPath('/images/launch/design.gif')
      question: t('news.design.title'),
      answer: t('news.design.desc', {
        img: getPublicPath('/images/launch/design.gif')
      })
    }
  ];
  return (
    <StyledContainer>
      <Heading2 editorial>{t('news.title')}</Heading2>
      <StyledNews>
        {news?.map((n, i) => {
          return (
            <FaqsItem
              key={i}
              question={n.question}
              active={n.active}
              answer={n.answer}
            />
          );
        })}
      </StyledNews>
      <ButtonLink href={`${getAppUrl(APP_URLS.login, locale)}`}>
        <FontAwesomeIcon icon={faCheckCircle} />
        <span>{t('news.cta')}</span>
      </ButtonLink>
    </StyledContainer>
  );
};

export default LaunchNews;
